/**
 * Roles and permissions — PLACEHOLDER defaults for the demo. In production the backend decides:
 * `GET /me` returns the user with `roles` and `permissions`, and the frontend only reads them.
 * The frontend hides what a user may not do; the backend must still enforce every rule.
 */
import type { Permission, Role, User } from '@/types/models';

export const ALL_PERMISSIONS: Permission[] = ['management:view', 'projects:write', 'members:write', 'worklog:write', 'updates:write', 'settings:write', 'backup:manage'];

export const ROLE_LABEL: Record<Role, string> = {
  admin: 'Admin',
  management: 'Management',
  manager: 'Manager',
  employee: 'Employee',
};

/** Suggested defaults; confirm with the product owner before go-live. */
export const ROLE_PERMISSIONS: Record<Role, Permission[]> = {
  admin: ALL_PERMISSIONS,
  management: ['management:view'],
  manager: ['management:view', 'projects:write', 'members:write', 'worklog:write', 'updates:write'],
  employee: ['worklog:write', 'updates:write'],
};

export const PERMISSION_LABEL: Record<Permission, string> = {
  'management:view': 'Open the Management View',
  'projects:write': 'Add, edit and delete projects, deadlines, links and metrics',
  'members:write': 'Add, edit and delete members',
  'worklog:write': 'Add, edit and delete Employee Log Work',
  'updates:write': 'Add, edit and delete Project Log Work',
  'settings:write': 'Change report settings',
  'backup:manage': 'Export and import backups, import .docx, delete all data',
};

export const permissionsFor = (roles: Role[]): Permission[] => [...new Set(roles.flatMap((r) => ROLE_PERMISSIONS[r] || []))];

export const can = (user: User | null | undefined, perm: Permission): boolean => !!user && user.permissions.includes(perm);
